import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
} from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import * as z from "zod";

export const getStorageLocationsCount = {
  name: "getStorageLocationsCount" as const,
  input: z.object({
    search: z.string().nullish(),
    filterGroup: FilterGroupSchema.nullish(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
    includeTotes: z.boolean().optional(),
    includeTransit: z.boolean().optional(),
  }),
  output: z.object({ total: z.number() }),
};
